import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import PlanSwitcher, { type PlanSwitcherData } from '../TopDown/components/PlanSwitcher'
import PlanTabs from './PlanTabs'

// Top row shared by the planning pages: session PlanSwitcher chip on the
// left, the page tabs centered (tabs={false} for pages outside the tab set,
// e.g. Plan vs Actual; the edit pages put their notice card there via
// center). redirectPath re-enters the current page after a plan switch
// (defaults to the Top Down index inside PlanSwitcher). actions render in
// the right column so the middle stays centered.
export default function PlanNavRow({
  planSwitcher,
  redirectPath,
  className,
  tabs = true,
  center,
  actions,
}: {
  planSwitcher: PlanSwitcherData
  redirectPath?: string
  className?: string
  tabs?: boolean
  center?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className={cn('grid grid-cols-[1fr_auto_1fr] items-center gap-4', className)}>
      <div
        style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
        className="justify-self-start border rounded-lg px-4 py-2.5"
      >
        <PlanSwitcher data={planSwitcher} redirectPath={redirectPath} />
      </div>
      {tabs ? <PlanTabs /> : center}
      {actions && <div className="col-start-3 justify-self-end">{actions}</div>}
    </div>
  )
}
